import { Column } from 'shared/types/models/EditMetrics';

export function getRatioColumnsIndexes(columns: Column[]): number[] {
  return columns.reduce<number[]>((acc, column, colIndex) => column.kind === 'ratio' ? [...acc, colIndex] : acc, []);
}
